(() => {
  if (!customElements.get('fd-menu-mobile')) {
    customElements.define('fd-menu-mobile', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const opts = {signal:this.lifecycle.signal};
        this.triggers = [...document.querySelectorAll('.fd-nav-open')];
        this.triggers.forEach(trigger => {
          trigger.setAttribute('aria-controls',this.id);
          trigger.setAttribute('aria-expanded','false');
          trigger.addEventListener('click',event => {event.preventDefault();this.opener=trigger;this.open();},opts);
        });
        this.querySelector('.fd-menu-close').addEventListener('click',()=>this.close(),opts);
        this.previousElementSibling?.addEventListener('click',()=>this.close(),opts);
        this.querySelectorAll('.fd-menu-group').forEach(group=>group.addEventListener('toggle',()=>{
          if(group.open)this.querySelectorAll('.fd-menu-group').forEach(other=>{if(other!==group)other.open=false;});
        },opts));
        const brandSearch=this.querySelector('.fd-brand-search');
        brandSearch?.addEventListener('input',()=>{
          const query=brandSearch.value.trim().toLocaleLowerCase();
          let count=0;
          this.querySelectorAll('[data-fd-brand]').forEach(link=>{
            const match=link.textContent.toLocaleLowerCase().includes(query);
            link.hidden=!match;if(match)count++;
          });
          this.querySelector('.fd-brand-empty').hidden=count>0;
        },opts);
        document.addEventListener('keydown',event=>{
          if(!this.isOpen)return;
          if(event.key==='Escape'){event.preventDefault();event.stopPropagation();this.close();return;}
          if(event.key!=='Tab')return;
          const items=[...this.querySelectorAll('a[href],button,input:not([type=hidden]),summary,[tabindex="0"]')].filter(el=>el.getClientRects().length && !el.disabled && getComputedStyle(el).visibility!=='hidden');
          const first=items[0],last=items.at(-1);
          if(event.shiftKey&&(document.activeElement===first||!this.contains(document.activeElement))){event.preventDefault();last?.focus();}
          else if(!event.shiftKey&&(document.activeElement===last||!this.contains(document.activeElement))){event.preventDefault();first?.focus();}
        },{...opts,capture:true});
        this.observer = new MutationObserver(()=>this.sync());
        this.observer.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
        this.desktop=matchMedia('(min-width:1025px)');
        this.desktop.addEventListener('change',event=>{if(event.matches&&this.isOpen)this.close();},opts);
        this.addEventListener('click',event=>{if(event.target.closest('a[href]'))this.close(false);},opts);
        this.sync();
      }
      open(){document.documentElement.classList.add('mobile-nav-active','show-overly');this.sync();}
      close(restore=true){this.restoreFocus=restore;document.documentElement.classList.remove('mobile-nav-active','show-overly');this.sync();}
      sync(){
        const open=document.documentElement.classList.contains('mobile-nav-active');
        if(open===this.isOpen)return;
        this.isOpen=open;this.inert=!open;this.setAttribute('aria-hidden',String(!open));
        this.triggers.forEach(trigger=>trigger.setAttribute('aria-expanded',String(open)));
        if(open){this.restoreFocus=true;this.querySelector('.fd-menu-close').focus({preventScroll:true});}
        else if(this.restoreFocus!==false&&this.opener?.isConnected){this.opener.focus({preventScroll:true});}
      }
      disconnectedCallback(){this.lifecycle?.abort();this.observer?.disconnect();if(this.isOpen)document.documentElement.classList.remove('mobile-nav-active','show-overly');}
    });
  }
  if (!customElements.get('fd-menu-desktop')) {
    customElements.define('fd-menu-desktop', class extends HTMLElement {
      connectedCallback(){
        this.lifecycle?.abort();this.lifecycle=new AbortController();const opts={signal:this.lifecycle.signal};
        this.groups=[...this.querySelectorAll('.fd-desktop-group')];
        const closeAll=except=>this.groups.forEach(group=>{if(group!==except)group.open=false;});
        this.groups.forEach(group=>{
          group.addEventListener('toggle',()=>{if(group.open)closeAll(group);},opts);
          group.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){clearTimeout(this.closeTimer);this.openTimer=setTimeout(()=>{closeAll(group);group.open=true;},100);}},opts);
          group.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'){clearTimeout(this.openTimer);this.closeTimer=setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false;},180);}},opts);
        });
        document.addEventListener('click',event=>{if(!this.contains(event.target))closeAll();},opts);
        document.addEventListener('keydown',event=>{if(event.key==='Escape'){const group=this.groups.find(g=>g.open);if(group){event.preventDefault();group.open=false;group.querySelector('summary').focus();}}},opts);
        this.addEventListener('focusout',()=>{queueMicrotask(()=>{if(!this.contains(document.activeElement))closeAll();});},opts);
      }
      disconnectedCallback(){this.lifecycle?.abort();clearTimeout(this.openTimer);clearTimeout(this.closeTimer);}
    });
  }
})();

